import clsx from 'clsx';
import type { PropsWithChildren } from 'react';
import { useId } from 'react';

import styles from '@/app/cc/_component/ui/common/Button/Button.module.scss';

type Props = PropsWithChildren<{
  readonly color?: 'primary' | 'secondary' | 'dark' | 'danger';
  readonly size?: 'sm' | 'md' | 'lg' | 'xl';
  readonly variant?: 'fill' | 'ghost' | 'line';
  readonly display?: 'inline' | 'block' | 'full';
  readonly layout?: 'fill' | 'hug';
  readonly type?: 'button' | 'submit' | 'reset';
  readonly disabled?: boolean;

  readonly className?: string;
  readonly onClick?: React.MouseEventHandler<HTMLElement>;
}>;

export default function Button(props: Props) {
  const {
    color = 'primary',
    type = 'button',
    size = 'xl',
    variant = 'fill',
    display = 'inline',
    layout = 'hug',
    disabled = false,
    className,
    onClick,
    children,
    ...rest
  } = props;
  const buttonId = useId();

  return (
    <button
      id={buttonId}
      type={type}
      className={clsx(
        styles.btn, // 기본 버튼
        styles[color], // 버튼 유형
        styles[size], // 크기
        styles[variant], // 스타일
        styles[display], // 형태 (inline, block, full)
        layout === 'fill' ? styles.layout_fill : styles.hug, // 레이아웃 (fill, hug)
        className,
      )}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}
